/*
 * View for the example translation
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicExampleModal/exampleTranslation/template/exampleTranslationTemplate.html",
], function (Marionette, ExampleTranslationTemplate) {
  var ExampleTranslationView = {};

  ExampleTranslationView.exampleTranslationView = Marionette.ItemView.extend({
    template: ExampleTranslationTemplate,
    modelEvents: {
      sync: "render",
    },
  });

  return ExampleTranslationView;
});
